import { createFileRoute } from '@tanstack/react-router';

import { ScreenStub } from '@/components/layout/ScreenStub';

export const Route = createFileRoute('/leagues/$leagueId/philanthropy')({
  component: Screen,
});

function Screen() {
  return (
    <ScreenStub
      title="Philanthropy"
      capability="philanthropy.view"
      planned="League pot, pot activation [T3], qualification status, per-user obligations, and the event ledger. This handles real charitable money: strictest confirmation in the product, a full immutable ledger, and never a silent edit."
    />
  );
}
